<template>
    <div class="full-content" style="background-image:url('assets/img/bg-gaspol-1.jpg');">
        <div class="card bg-card-trans border-0 rounded-0 mobile-ver">
            <div class="mobile-ver-top">
                <img src="assets/img/accent-1.png" class="accent-1">
                <div class="d-flex h-100 px-4 align-items-center justify-content-between">
                    <img src="assets/img/gaspol-ptn-logo-dark.svg" height="32" class="mobile-ver-logo">
                    <a href="#" class="btn btn-white-naked">
                        <i class="fa-solid fa-bell fa-lg"></i>
                    </a>
                </div>
            </div>
            <div class="mobile-ver-content">
                <div class="d-block p-4">
                    <div class="d-block text-muted mb-4 text-sm">Silahkan pilih menu dibawah ini</div>
                    <div class="row justify-content-center">
                        <div class="col-md-4 col-6 mb-4">
                            <a href="javascript:void(0)" class="menu-icon" v-on:click="goToPage('student_rapor')">
                                <div class="menu-icon-img mb-3">
                                    <img src="assets/img/dashboard-icon-2.png" alt="My Rapor">
                                </div>
                                <div class="menu-icon-text">My Rapor</div>
                            </a>
                        </div>
                        <div class="col-md-4 col-6 mb-4">
                            <a href="javascript:void(0)" class="menu-icon" v-on:click="goToPage('student_rationalization')">
                                <div class="menu-icon-img mb-3">
                                    <img src="assets/img/dashboard-icon-1.png" alt="Rasionalisasi">
                                </div>
                                <div class="menu-icon-text">Rasionalisasi</div>
                            </a>
                        </div>
                        <div class="col-md-4 col-6 mb-4">
                            <a href="javascript:void(0)" class="menu-icon" v-on:click="goToPage('student_alumni')">
                                <div class="menu-icon-img mb-3">
                                    <img src="assets/img/dashboard-icon-5.png" alt="Alumni">
                                </div>
                                <div class="menu-icon-text">Alumni</div>
                            </a>
                        </div>
                        <div class="col-md-4 col-6 mb-4">
                            <a href="javascript:void(0)" class="menu-icon" v-on:click="goToPage('student_major')">
                                <div class="menu-icon-img mb-3">
                                    <img src="assets/img/dashboard-icon-6.png" alt="Jurusan">
                                </div>
                                <div class="menu-icon-text">Jurusan</div>
                            </a>
                        </div>
                        <div class="col-md-4 col-6 mb-4">
                            <a href="javascript:void(0)" class="menu-icon" v-on:click="goToPage('student_consultation')">
                                <div class="menu-icon-img mb-3">
                                    <img src="assets/img/dashboard-icon-7.png" alt="Konsultasi">
                                </div>
                                <div class="menu-icon-text">Konsultasi</div>
                            </a>
                        </div>
                        <div class="col-md-4 col-6 mb-4">
                            <a href="javascript:void(0)" class="menu-icon" v-on:click="goToPage('student_talent')">
                                <div class="menu-icon-img mb-3">
                                    <img src="assets/img/dashboard-icon-8.png" alt="Minat Bakat">
                                </div>
                                <div class="menu-icon-text">Minat Bakat</div>
                            </a>
                        </div>
                        <div class="col-md-4 col-6 mb-4">
                            <a href="javascript:void(0)" class="menu-icon" v-on:click="goToPage('student_promotion')">
                                <div class="menu-icon-img mb-3">
                                    <img src="assets/img/dashboard-icon-9.png" alt="Promo TO">
                                </div>
                                <div class="menu-icon-text">Promo TryOut</div>
                            </a>
                        </div>
                        <div class="col-md-4 col-6 mb-4">
                            <a href="javascript:void(0)" class="menu-icon" v-on:click="goToPage('student_accompany')">
                                <div class="menu-icon-img mb-3">
                                    <img src="assets/img/dashboard-icon-10.png" alt="Dampingi">
                                </div>
                                <div class="menu-icon-text">Dampingi</div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <slot/>
            <div class="mobile-ver-bottom">
                <div class="d-block p-3">
                    <div class="card bg-transparent m-0">
                        <div class="d-block py-2">
                            <div class="d-flex align-items-center justify-content-center">
                                <a href="javascript:void(0)" class="menu-bottom mx-3 active">
                                    <i class="fa-solid fa-home fa-lg"></i>
                                    <div class="d-block pt-1">Home</div>
                                </a>
                                <a href="javascript:void(0)" class="menu-bottom mx-3" v-on:click="goToPage('student_profile')">
                                    <i class="fa-solid fa-user fa-lg"></i>
                                    <div class="d-block pt-1">Profil</div>
                                </a>
                                <a href="javascript:void(0)" class="menu-bottom mx-3" v-on:click="goToPage('signout')">
                                    <i class="fa-solid fa-sign-out fa-lg"></i>
                                    <div class="d-block pt-1">Keluar</div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'StudentDashboard',
    methods: {
        goToPage: function(params=null) {
            this.$router.push( {
                name : params
            })            
        }
    }
  }
</script>